import './FooterContainer.css'


import FooterInfo from '../FooterInfo/FooterInfo'
import FooterLegend from '../FooterLegend/FooterLegend'
import { useAppContext } from '../../../context/AppState/AppContext'

export default function FooterContainer() {
   const { jsonTexts, jsonMedia } = useAppContext()
   const { heading } = jsonTexts.footer
   const {footerBottomImage} = jsonMedia?.inicio
   return (
      <footer className='footer'>
         {heading.show && <FooterLegend title={heading.title} subtitle={heading.subtitle} />}
         < FooterInfo />
         < img className='footer-bkgImage' src={footerBottomImage} alt='foto de gato' />
      </footer>
   )
}
